var bulltbase;
! function($) {
  "use strict";
  bulltbase = function() {
    var basetheme = {
      popupEffect: "",
      supports_html5_storage: !1,
      ajaxLinks: ""
    };
    try {
      basetheme.supports_html5_storage = "sessionStorage" in window && null !== window.sessionStorage, window.sessionStorage.setItem("theme", "test"), window.sessionStorage.removeItem("theme")
    } catch (e) {
      basetheme.supports_html5_storage = !1
    }
    return {
      init: function() {
        this.shopcarousel();
        this.oneSlide();
        this.brandImage();
        this.quote();
        this.instagramd();
        this.image360();
        this.blog();
        this.threeslide();
        this.slidebuild();
        this.center_slide();
        this.timeline();
        this.slideshow();
      },
    
      center_slide: function() {
        void 0 !==  $(".slider_center").each(
          function(e) {
            var l = {
            
              dots: true,
              centerMode: true,
              slidesToShow: 1,
              centerPadding: "25%",
              arrows: true,
              autoplay: true,
              autoplaySpeed: 6000,
              nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow slick-initialized slick-slider" aria-label="Next" role="button" ><i class="material-icons-outlined">arrow_forward_ios</i></button>',
              prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" role="button" ><i class="material-icons-outlined">arrow_back_ios_new</i></button>',
              responsive: [{
                breakpoint: 768,
                settings: {
                centerMode: true,
                centerPadding: "20px",
                slidesToShow: 1
                }
              }]
            }
            $(this).slick(l);
          })
      },
      slideshow: function() {
        void 0 !==  $(".flexslider").each(
          function(e) {
             var d = $(this).data("dots"),
              b = $(this).data("nav"),
              p = $(this).data("speed"),
               h = $(this).data("hover"),
                 l = {
                   
                   slideshow: true,
                   animationDuration: 700,
                   slideshowSpeed: p,
                   controlsContainer: ".flex-controls",
                   controlNav: d,   
                   pauseOnHover: h,
                   directionNav: b, 
                   prevText: '<span class="material-icons-outlined">arrow_back_ios_new</span>',
                   nextText: '<span class="material-icons-outlined">arrow_forward_ios</span>',
                   keyboardNav: true
                 };
            $(this).flexslider(l).hover(function(){ $('.flex-direction-nav').fadeIn();}, function(){$('.flex-direction-nav').fadeOut();});
          })
      },
      slidebuild: function() {
        void 0 !==  $(".carousel-slide.owl-carousel ").each(
          function(e) {
            var p = $(this).data("desktop"),
                t = $(this).data("tablet"),
                m = $(this).data("mobile"),
                d = $(this).data("dot"),
                b = $(this).data("button"),
                l = {
                  rtl: $("body").hasClass("rtl"),
                  items: t,
                  responsive: {
                    1200: {
                      items: p
                    },
                    993: {
                      items: p
                    },
                    768: {
                      items: t
                    },
                    479: {
                      items: m
                    },
                    0: {
                      items: m
                    }
                  },
                  autoplay: true,
                  autoplayTimeout: 5000,
                  dots: d,
                  autoplayHoverPause:true,
                  nav: b,
                  navText: ['<i class="material-icons-outlined">arrow_back_ios_new</i>','<i class="material-icons-outlined">arrow_forward_ios</i>'],
                  autoheight: !0,
                  slideBy: "page",
                  loop: true,
                  onRefreshed: function() {
                    $(window).resize()
                  }
                };
          
            $(this).owlCarousel(l)
          })
      },
      shopcarousel: function() {
        void 0 !==  $(".slider.owl-carousel ").each(
          function(e) {
            var t = $(this).data("limit"),
                b = $(this).data("button"),
                s = $(this).data("dots"),
                a = ($(this).data("medium"), $(this).data("time")),
                i = $(this).data("loop"),
                n = $(this).data("autoplay"),
                sp = $(this).data("speed"),
         
                l = {
                  rtl: $("body").hasClass("rtl"),
                  items: t,
                  responsive: {
                    979: {
                      items: t
                    },
                    768: {
                      items: 3
                    },
                    576: {
                      items: 2
                    },
                    0: {
                      items: 1
                    }
                  },
                  autoplay: n,
                  autoplayTimeout: 5000,
                  dots: s,
                  autoplayHoverPause:true,
                  nav: b,
                  navText: ['<i class="material-icons-outlined">arrow_back_ios_new</i>','<i class="material-icons-outlined">arrow_forward_ios</i>'],
                  autoheight: !0,
                  slideBy: "page",
                  loop: true,
                  onRefreshed: function() {
                    $(window).resize()
                  }
                };
                   console.log(b);
            $(this).owlCarousel(l)
          })
      },
      blog: function() {
        void 0 !==  $(".slide-blog.owl-carousel ").each(
          function(e) {
            var t = $(this).data("limit"),
                o = $(this).data("nav"),
                s = $(this).data("dots"),
                a = ($(this).data("medium"), $(this).data("time")),
                i = $(this).data("loop"),
                n = $(this).data("autoplay"),
                l = {
                  rtl: $("body").hasClass("rtl"),
                  items: t,
                  responsive: {
                    979: {
                      items: t
                    },
                    768: {
                      items: 2
                    },
                    479: {
                      items: 1
                    },
                    0: {
                      items: 1
                    }
                  },
                  autoplay: true,
                  autoplayTimeout: 5000,
                  dots: true,
                  autoplayHoverPause:true,
                  nav: true,
                  navText: ['<i class="material-icons-outlined">arrow_back_ios_new</i>','<i class="material-icons-outlined">arrow_forward_ios</i>'],
                  autoheight: !0,
                  slideBy: "page",
                  loop: true,
                  onRefreshed: function() {
                    $(window).resize()
                  }
                };
            $(this).owlCarousel(l)
          })
      },
      oneSlide: function() {
        void 0 !==  $(".one.owl-carousel ").each(
          function(e) {
            var t = $(this).data("limit"),
                o = $(this).data("button"),
                s = $(this).data("dots"),
                a = ($(this).data("medium"), $(this).data("time")),
                i = $(this).data("loop"),
                n = $(this).data("autoplay"),
                l = {
                  rtl: $("body").hasClass("rtl"),
                  items: 1,
                  autoplay: n,
                  autoplayTimeout: 5000,
                  dots: s,
                  autoplayHoverPause:true,
                  nav: o,
                  autoheight: !0,
                  slideBy: "page",
                  navText: ['<i class="material-icons-outlined">arrow_back_ios_new</i>','<i class="material-icons-outlined">arrow_forward_ios</i>'],
                  loop: false,
                  onRefreshed: function() {
                    $(window).resize()
                  }
                };
            $(this).owlCarousel(l)
          })
      },
      threeslide: function() {
        void 0 !==  $(".threeslide.owl-carousel ").each(
          function(e) {
            var t = $(this).data("limit"),
                o = $(this).data("nav"),
                s = $(this).data("dots"),
                a = ($(this).data("medium"), $(this).data("time")),
                i = $(this).data("loop"),
                n = $(this).data("autoplay"),
                l = {
                  rtl: $("body").hasClass("rtl"),
                  items: t,
                  responsive: {
                    979: {
                      items: 3
                    },
                    768: {
                      items: 3
                    },
                    479: {
                      items: 2
                    },
                    0: {
                      items: 1
                    }
                  },
                  autoplay: true,
                  autoplayTimeout: 5000,
                  dots: true,
                  autoplayHoverPause:true,
                  nav: true,
                  autoheight: !0,
                  slideBy: "page",
                  navText: ['<i class="material-icons-outlined">arrow_back_ios_new</i>','<i class="material-icons-outlined">arrow_forward_ios</i>'],
                  loop: true,
                  onRefreshed: function() {
                    $(window).resize()
                  }
                };
            $(this).owlCarousel(l)
          })
      },
      brandImage: function() {
        void 0 !==  $(".slide.owl-carousel ").each(
          function(e) { 
            var t = $(this).data("limit"),
                 b = $(this).data("button"),
                s = $(this).data("dots"),
                a = ($(this).data("medium"), $(this).data("time")),
                i = $(this).data("loop"),
                n = $(this).data("autoplay"),
                l = {
                  rtl: $("body").hasClass("rtl"),
                  items: t,
                  responsive: {
                   
                    1200: {
                      items:  t
                    },
                     1024: {
                      items: 5
                    },
                    991: {
                      items: 4
                    },
                    768: {
                      items: 4
                    },
                    479: {
                      items: 3
                    },
                    0: {
                      items: 2
                    }
                  },
                  autoplay: n,
                  autoplayTimeout: 5000,
                  dots: s,
                  autoplayHoverPause:true,
                  nav: b,
                  autoheight: !0,
                  slideBy: "page",
                  navText: ['<i class="material-icons-outlined">arrow_back_ios_new</i>','<i class="material-icons-outlined">arrow_forward_ios</i>'],
                  loop: true,
                  onRefreshed: function() {
                    $(window).resize()
                  }
                };
            $(this).owlCarousel(l)
          })
      },
      quote: function() {
        void 0 !==  $(".quotes-slider.owl-carousel ").each(
          function(e) {
            var d = $(this).data("desktop"),
                t = $(this).data("tablet"),
                m = $(this).data("mobile"),
                a = ($(this).data("medium"), $(this).data("time")),
                i = $(this).data("loop"),
                n = $(this).data("autoplay"),
                l = {
                  rtl: $("body").hasClass("rtl"),
                  items: d,
                  responsive: {
                    979: {
                      items: d
                    },
                    768: {
                      items: t
                    },
                    479: {
                      items: m
                    },
                    0: {
                      items: m
                    }
                  },
                  autoplay: true,
                  autoplayTimeout: 5000,
                  dots: true,
                  nav: true,
                  autoheight: !0,
                  autoplayHoverPause:true,
                  slideBy: "page",
                  navText: ['<i class="material-icons-outlined">arrow_back_ios_new</i>','<i class="material-icons-outlined">arrow_forward_ios</i>'],
                  loop: true,
                  onRefreshed: function() {
                    $(window).resize()
                  }
                };
            $(this).owlCarousel(l)
          })
      },
      instagramd: function() {
        void 0 !==  $(".instafeed").each(
          function(e) {
            var d = $(this).data("user"),
                t = $(this).data("token"),
                m = $(this).data("clienid"),
                a = ($(this).data("medium"), $(this).data("time")),
                i = $(this).data("limit"),
                n = $(this).data("image"),
                o = $(this).data("arrows"),
                  c = $(this).data("carousel"),
                s = $(this).data("dots"),
                feed = new Instafeed({
                  get: "user",    

                  userId: d,
                  accessToken: t,

                  clientId: m,
                  limit: i,
                  resolution: n,
                  after: function() {
                    setTimeout(function(){
                    $('.instafeed > a').attr( "target", "_blank" );
                    $(".instafeed.slides-owl").owlCarousel({
                      loop:false,
                      margin:1,
                      responsiveClass:true,
                      dots: s,
                      nav: o,
                      navText: ['<i class="material-icons-outlined">arrow_back_ios_new</i>','<i class="material-icons-outlined">arrow_forward_ios</i>'],
                      responsive:{
                        0:{
                          items:1
                        },
                        600:{
                          items:2
                        },
                        800:{
                          items:3
                        },
                        1000:{
                          items:c,
                          loop:false
                        }
                      }
                    });
//                       jQuery('.instafeed.grid > a').attr( "target", "_blank" );
//                       var count_a = jQuery(".instafeed.grid" ).width();
//                       var width_item = count_a / i - 0.3 ;
//                       jQuery(".instafeed.grid a").css("width", width_item);
//                       jQuery('.instafeed.grid > a').addClass('col-md-2');
//                       jQuery('.instafeed.grid ').addClass('row');
					 }, 2000);
                   
                  }
                });
            feed.run();
          }
        )
      },
      timeline: function() {
        void 0 !==  $(".timeline-block").each(
          function(e) {
            var t = $(this).data("time"),
                l = {
                  TargetDate:t,

                  DisplayFormat:"<div class='day'><span class='no'>%%D%%</span><span class='text'>days</span></div><div class='hours'><span class='no'>%%H%%</span><span class='text'>hours</span></div><div class='min'><span class='no'>%%M%%</span><span class='text'>min</span></div><div class='second'><span class='no'>%%S%%</span><span class='text'>sec</span></div>",
                  FinishMessage: "Expired",
                  onRefreshed: function() {
                    $(window).resize()
                  }
                };
            $(this).lofCountDown(l)
          })
      },
      image360: function() {
        void 0 !==  $(".product-image-360").each(
          function(e) {
            var string = $(this).data("allimage");
            var array = string.split(',');
            var count_ht = array.length;
            var  l = {
              totalFrames: count_ht,
              endFrame: count_ht, 
              currentFrame: 1, 
              imgList: '.product-images-item', 
              progress: '.spinner',
              imgArray: array,
              height: null,
              width: null,
              responsive: true,
              navigation: false
            };

            $('.custom_previous').bind('click', function(e) {
              car.previous();
            });

            $('.custom_next').bind('click', function(e) {
              car.next();
            });

            $('.custom_play').bind('click', function(e) {
              car.play();
              $('.nav_bar').addClass('play-video');
            });

            $('.custom_stop').bind('click', function(e) {
              car.stop();
              $('.nav_bar').removeClass('play-video');
            });

            $(this).ThreeSixty(l)
          })
      }
    }
  }()
}(jQuery), 
  jQuery(document).ready(function() {
  bulltbase.init()
}), jQuery(document).on("shopify:section:load", bulltbase.shopcarousel).on("shopify:section:unload", bulltbase.shopcarousel).on("shopify:section:select", bulltbase.shopcarousel).on("shopify:section:deselect", bulltbase.shopcarousel).on("shopify:block:select", bulltbase.shopcarousel).on("shopify:block:deselect", bulltbase.shopcarousel)
jQuery(document).on("shopify:section:load", bulltbase.quote).on("shopify:section:unload", bulltbase.quote).on("shopify:section:select", bulltbase.quote).on("shopify:section:deselect", bulltbase.quote).on("shopify:block:select", bulltbase.quote).on("shopify:block:deselect", bulltbase.quote),
  jQuery(document).on("shopify:section:load", bulltbase.instagramd).on("shopify:section:unload", bulltbase.instagramd).on("shopify:section:select", bulltbase.instagramd).on("shopify:section:deselect", bulltbase.instagramd).on("shopify:block:select", bulltbase.instagramd).on("shopify:block:deselect", bulltbase.instagramd),
  jQuery(document).on("shopify:section:load", bulltbase.brandImage).on("shopify:section:unload", bulltbase.brandImage).on("shopify:section:select", bulltbase.brandImage).on("shopify:section:deselect", bulltbase.brandImage).on("shopify:block:select", bulltbase.brandImage).on("shopify:block:deselect", bulltbase.brandImage),
  jQuery(document).on("shopify:section:load", bulltbase.oneSlide).on("shopify:section:unload", bulltbase.oneSlide).on("shopify:section:select", bulltbase.oneSlide).on("shopify:section:deselect", bulltbase.oneSlide).on("shopify:block:select", bulltbase.oneSlide).on("shopify:block:deselect", bulltbase.oneSlide),
  jQuery(document).on("shopify:section:load", bulltbase.timeline).on("shopify:section:unload", bulltbase.timeline).on("shopify:section:select", bulltbase.timeline).on("shopify:section:deselect", bulltbase.timeline).on("shopify:block:select", bulltbase.timeline).on("shopify:block:deselect", bulltbase.timeline),
  jQuery(document).on("shopify:section:load", bulltbase.image360).on("shopify:section:unload", bulltbase.image360).on("shopify:section:select", bulltbase.image360).on("shopify:section:deselect", bulltbase.image360).on("shopify:block:select", bulltbase.image360).on("shopify:block:deselect", bulltbase.image360),
    jQuery(document).on("shopify:section:load", bulltbase.blog).on("shopify:section:unload", bulltbase.blog).on("shopify:section:select", bulltbase.blog).on("shopify:section:deselect", bulltbase.blog).on("shopify:block:select", bulltbase.blog).on("shopify:block:deselect", bulltbase.blog),
    jQuery(document).on("shopify:section:load", bulltbase.slidebuild).on("shopify:section:unload", bulltbase.slidebuild).on("shopify:section:select", bulltbase.slidebuild).on("shopify:section:deselect", bulltbase.slidebuild).on("shopify:block:select", bulltbase.slidebuild).on("shopify:block:deselect", bulltbase.slidebuild),
  jQuery(document).on("shopify:section:load", bulltbase.slideshow).on("shopify:section:unload", bulltbase.slideshow).on("shopify:section:select", bulltbase.slideshow).on("shopify:section:deselect", bulltbase.slideshow).on("shopify:block:select", bulltbase.slideshow).on("shopify:block:deselect", bulltbase.slideshow),
  
   jQuery(document).on("shopify:section:load", bulltbase.center_slide).on("shopify:section:unload", bulltbase.center_slide).on("shopify:section:select", bulltbase.center_slide).on("shopify:section:deselect", bulltbase.center_slide).on("shopify:block:select", bulltbase.center_slide).on("shopify:block:deselect", bulltbase.center_slide),
 jQuery(document).on("shopify:section:load", bulltbase.threeslide).on("shopify:section:unload", bulltbase.threeslide).on("shopify:section:select", bulltbase.threeslide).on("shopify:section:deselect", bulltbase.threeslide).on("shopify:block:select", bulltbase.threeslide).on("shopify:block:deselect", bulltbase.threeslide);

